// extracted by mini-css-extract-plugin
module.exports = {"errorList":"Styles_errorList__3ckxw"};